
  import createMeisterIcons from '../src/createMeisterIcons';

  const Mouse = createMeisterIcons("mouse", [["path",{"fill":"currentColor","d":"M6.299 9.45a5.63 5.63 0 0 1 5.65-5.65h.1a5.63 5.63 0 0 1 5.65 5.65v5.121c.087 3.058-2.452 5.63-5.65 5.63h-.1a5.63 5.63 0 0 1-5.65-5.651zm5.65-7.15a7.13 7.13 0 0 0-7.15 7.15v5.1a7.13 7.13 0 0 0 7.15 7.15h.1c3.998 0 7.256-3.223 7.15-7.16V9.45a7.13 7.13 0 0 0-7.15-7.15zm.85 5.65a.75.75 0 0 0-1.5 0v2a.75.75 0 1 0 1.5 0z","key":"4d848fbc9984413dc735c19561b52615108a329b","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Mouse
  